// src/components/contact.js
import React from 'react';

const Contact = React.memo(() => (
  <div style={{ padding: '3rem 2rem', background: '#fff', borderRadius: '8px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)', margin: '2rem auto', maxWidth: '800px' }}>
    <h2>Contact Us</h2>
    <p>Email: info@jewelleryshop.com</p>
    <p>Phone: (123) 456-7890</p>
    <form>
      <input type="text" placeholder="Name" />
      <input type="email" placeholder="Email" />
      <textarea placeholder="Message"></textarea>
      <button type="submit">Send</button>
    </form>
  </div>
));

export default Contact;